/**
 * ============================================================================
 * Layout Dynamic Imports (MVC View Registry)
 * ============================================================================
 *
 * Header is a static import so first paint doesn't flash empty → header
 * (dynamic() loading was a major flicker source on the first fold).
 * Below-fold chrome stays code-split.
 * Note: Turbopack requires dynamic() options as object literals.
 * ============================================================================
 */

"use client";

import dynamic from "next/dynamic";
import { memo } from "react";
import HeaderNewBase from "@/components/organisms/HeaderNew";

/** Static — no loading gap / layout flicker on first fold. */
export const HeaderNew = memo(HeaderNewBase);

export const FooterNew = dynamic(
  () =>
    import("@/components/organisms/HomeNewFooter/FooterNew").then((mod) => ({
      default: memo(mod.default),
    })),
  { ssr: true, loading: () => null }
);

export const SideButtons = dynamic(
  () =>
    import("@/components/atoms/SideButtons").then((mod) => ({
      default: memo(mod.default),
    })),
  { ssr: false, loading: () => null }
);

export const EnrollNowSticky = dynamic(
  () =>
    import("@/components/atoms/EnrollNowSticky/EnrollNowSticky").then(
      (mod) => ({ default: memo(mod.default) })
    ),
  { ssr: false, loading: () => null }
);

export const StickyWidget = dynamic(
  () =>
    import("@/components/atoms/StickyWidget/StickyWidget").then((mod) => ({
      default: memo(mod.default),
    })),
  { ssr: false, loading: () => null }
);
